import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1996636e from 'nuxt_plugin_plugin_1996636e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_5357bf48 from 'nuxt_plugin_sentryserver_5357bf48' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_24c36480 from 'nuxt_plugin_sentryclient_24c36480' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_microcms_4de7f72f from 'nuxt_plugin_microcms_4de7f72f' // Source: ./microcms.js (mode: 'all')
import nuxt_plugin_toast_18401033 from 'nuxt_plugin_toast_18401033' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_templatesplugin785c6982_1acc4730 from 'nuxt_plugin_templatesplugin785c6982_1acc4730' // Source: ./templates.plugin.785c6982.js (mode: 'all')
import nuxt_plugin_vuejsoncsv_a530328e from 'nuxt_plugin_vuejsoncsv_a530328e' // Source: ../plugins/vue-json-csv.js (mode: 'all')
import nuxt_plugin_amplify_900d1ace from 'nuxt_plugin_amplify_900d1ace' // Source: ../plugins/amplify.js (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'client')
import nuxt_plugin_vuejstogglebutton_66316bf6 from 'nuxt_plugin_vuejstogglebutton_66316bf6' // Source: ../plugins/vue-js-toggle-button (mode: 'all')
import nuxt_plugin_vueselectimage_45a6e408 from 'nuxt_plugin_vueselectimage_45a6e408' // Source: ../plugins/vue-select-image (mode: 'all')
import nuxt_plugin_vuejsprogressbar_f49e7770 from 'nuxt_plugin_vuejsprogressbar_f49e7770' // Source: ../plugins/vuejs-progress-bar (mode: 'all')
import nuxt_plugin_vueyoutube_6236cda5 from 'nuxt_plugin_vueyoutube_6236cda5' // Source: ../plugins/vue-youtube (mode: 'all')
import nuxt_plugin_vuecroppie_49946104 from 'nuxt_plugin_vuecroppie_49946104' // Source: ../plugins/vue-croppie (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_vueinfinitescroll_5d2c1fcf from 'nuxt_plugin_vueinfinitescroll_5d2c1fcf' // Source: ../plugins/vue-infinite-scroll.js (mode: 'all')
import nuxt_plugin_i18n_3032693c from 'nuxt_plugin_i18n_3032693c' // Source: ../plugins/i18n.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | ナレッジ・ループ","title":"オンラインコーチングサポートツール","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Knowledge Loopは、オンラインでのコーチング、相互学習の支援を行う企業・個人に最適なプラットフォームです。コーチと学習者間のチャット、実践動画の共有、タイムスタンプ付きのフィードバック機能を提供し、どこにいても効果的な学習環境を実現します。自分のスキルを活かして副業を始めたい方にも理想的。今すぐ無料で始めましょう。"}],"script":[{"src":"https:\u002F\u002Fjs.pay.jp\u002Fv2\u002Fpay.js","async":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-21BXBKRXJ4","async":true},{"hid":"gtag","type":"text\u002Fjavascript","innerHTML":"\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', 'G-21BXBKRXJ4');\n          gtag('config', 'UA-263168989-1');\n        "},{"hid":"ld-json","type":"application\u002Fld+json","innerHTML":"{\"@context\":\"http:\u002F\u002Fschema.org\",\"@type\":\"LocalBusiness\",\"name\":\"ナレッジ・ループ株式会社\",\"logo\":\"https:\u002F\u002Fwww.knowledgeloop.jp\u002F_nuxt\u002Fimg\u002Ftop__logo-text.362a675.svg\",\"telephone\":\"+81 50-3612-7417\",\"email\":\"info@knowledgeloop.jp\",\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"中区日本大通７ 日本大通７ビル４階YBP\",\"addressLocality\":\"横浜市\",\"addressRegion\":\"神奈川県\",\"addressCountry\":\"JP\",\"postalCode\":\"231-0021 \"},\"url\":\"https:\u002F\u002Fwww.knowledgeloop.jp\u002F\"}"}],"__dangerouslyDisableSanitizersByTagID":{"gtag":["innerHTML"],"ld-json":["innerHTML"]},"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"alternate icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fx-icon","sizes":"32x32","href":"\u002Ffavicon-32x32.ico"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg"},{"rel":"apple-touch-icon","sizes":"180x180","href":"apple-icon-180x180.png"},{"rel":"android-touch-icon","sizes":"192x192","href":"android-icon-192x192.png"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1996636e === 'function') {
    await nuxt_plugin_plugin_1996636e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_5357bf48 === 'function') {
    await nuxt_plugin_sentryserver_5357bf48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_24c36480 === 'function') {
    await nuxt_plugin_sentryclient_24c36480(app.context, inject)
  }

  if (typeof nuxt_plugin_microcms_4de7f72f === 'function') {
    await nuxt_plugin_microcms_4de7f72f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_18401033 === 'function') {
    await nuxt_plugin_toast_18401033(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin785c6982_1acc4730 === 'function') {
    await nuxt_plugin_templatesplugin785c6982_1acc4730(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsoncsv_a530328e === 'function') {
    await nuxt_plugin_vuejsoncsv_a530328e(app.context, inject)
  }

  if (typeof nuxt_plugin_amplify_900d1ace === 'function') {
    await nuxt_plugin_amplify_900d1ace(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejstogglebutton_66316bf6 === 'function') {
    await nuxt_plugin_vuejstogglebutton_66316bf6(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselectimage_45a6e408 === 'function') {
    await nuxt_plugin_vueselectimage_45a6e408(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsprogressbar_f49e7770 === 'function') {
    await nuxt_plugin_vuejsprogressbar_f49e7770(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_6236cda5 === 'function') {
    await nuxt_plugin_vueyoutube_6236cda5(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecroppie_49946104 === 'function') {
    await nuxt_plugin_vuecroppie_49946104(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinfinitescroll_5d2c1fcf === 'function') {
    await nuxt_plugin_vueinfinitescroll_5d2c1fcf(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_3032693c === 'function') {
    await nuxt_plugin_i18n_3032693c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
